import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const state = {
    routerName: '/f_home'
}


export default new Vuex.Store({
    state,
    mutations: {
        routerName(state, val) {
            state.routerName = val
        }
    },
    plugins: [persistedState()]
})


// WEBPACK FOOTER //
// ./src/store/index.js